// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PostMenu__item--admin":"re_a","PostMenu__item--moderator":"re_b","PostMenu__item--author":"re_c"};